import { MOBEES_API_URL } from '@shared/constants/API.constants';
import { formatDataForCampaign } from '@domain/partnerships/partners/mobees/new-campaign/campaign/campaign.utils';

export const getMobeesDraftCampaignApiConfig = () => ({
    url: '/api/campaigns',
    method: 'GET',
    params: { includeStatus: 'draft' },
    baseURL: MOBEES_API_URL,
});

export const createMobeesCampaignApiConfig = data => ({
    url: '/api/campaigns',
    method: 'POST',
    data: formatDataForCampaign(data),
    baseURL: MOBEES_API_URL,
});

export const updateMobeesCampaignApiConfig = (campaignId, data) => ({
    url: `/api/campaigns/${campaignId}`,
    method: 'PUT',
    data: formatDataForCampaign(data),
    baseURL: MOBEES_API_URL,
});
